/* eslint-disable react/prop-types */
import React from 'react';
import {
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    FormHelperText,
    ListItemText,
    OutlinedInput,
    Checkbox,
    Box,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    Autocomplete
} from '@mui/material';
import { Field, ErrorMessage } from 'formik';
import { roles } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';
import HelpIcon from './HelpIcon';
import { tips } from './HelpData';

const Remarks = ({ role, values, handleChange, handleBlur, setFieldValue, touched, errors }) => (
    <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12}>
            <Typography
                sx={{
                    color: '#919191',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    textTransform: 'capitalize',
                    mb: 2
                }}
            >
                Remarks Information
            </Typography>
            <SubCard>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                    Directions
                                </Typography>
                            </FormLabel>
                            <HelpIcon
                                title={tips?.Directions.title}
                                ruleHelp={tips?.Directions.ruleHelp}
                                generalHelpDesc={tips?.Directions.generalHelpDesc}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'end' }}>
                            <Field
                                as={TextField}
                                fullWidth
                                name="directions"
                                variant="outlined"
                                multiline
                                rows={4}
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.directions}
                                error={touched.directions && Boolean(errors.directions)}
                                helperText={<ErrorMessage name="directions" />}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                    Public Remarks
                                </Typography>
                            </FormLabel>
                            <HelpIcon
                                title={tips?.PublicRemarks.title}
                                ruleHelp={tips?.PublicRemarks.ruleHelp}
                                generalHelpDesc={tips?.PublicRemarks.generalHelpDesc}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'end' }}>
                            <Field
                                as={TextField}
                                fullWidth
                                name="publicRemarks"
                                variant="outlined"
                                multiline
                                rows={4}
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.publicRemarks}
                                error={touched.publicRemarks && Boolean(errors.publicRemarks)}
                                helperText={<ErrorMessage name="publicRemarks" />}
                            />
                        </Box>
                        <Typography variant="caption" color="textSecondary">
                            Note: Please provide a concise summary of your property for public viewing.
                        </Typography>
                    </Grid>

                    {role === roles.ADMIN && (
                        <Grid item xs={12} sm={6}>
                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                        Private Remarks
                                    </Typography>
                                </FormLabel>
                                <HelpIcon
                                    title={tips?.PrivateRemarks.title}
                                    ruleHelp={tips?.PrivateRemarks.ruleHelp}
                                    generalHelpDesc={tips?.PrivateRemarks.generalHelpDesc}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'end' }}>
                                <Field
                                    as={TextField}
                                    fullWidth
                                    name="privateRemarks"
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.privateRemarks}
                                    error={touched.privateRemarks && Boolean(errors.privateRemarks)}
                                    helperText={<ErrorMessage name="privateRemarks" />}
                                />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </SubCard>
        </Grid>

        <Grid item xs={12}>
            <Typography
                sx={{
                    color: '#919191',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                    textTransform: 'capitalize',
                    mb: 2
                }}
            >
                Internet Display Information
            </Typography>
            <SubCard>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex' }}>
                            <FormControl
                                fullWidth
                                required
                                variant="outlined"
                                error={touched.internetListingDisplay && Boolean(errors.internetListingDisplay)}
                            >
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Internet Entire Listing Display
                                        </Typography>
                                    </FormLabel>
                                    <HelpIcon
                                        title={tips?.internetListingDisplay.title}
                                        ruleHelp={tips?.internetListingDisplay.ruleHelp}
                                        generalHelpDesc={tips?.internetListingDisplay.generalHelpDesc}
                                    />
                                </Box>
                                <RadioGroup
                                    name="internetListingDisplay"
                                    value={values.internetListingDisplay}
                                    onChange={handleChange}
                                    row
                                    sx={{ gap: 1, ml: 1, mt: 1 }}
                                >
                                    <FormControlLabel
                                        value="YES"
                                        control={<Radio />}
                                        label="YES"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />

                                    <FormControlLabel
                                        value="NO"
                                        control={<Radio />}
                                        label="NO"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />
                                </RadioGroup>

                                {touched.internetListingDisplay && errors.internetListingDisplay && (
                                    <FormHelperText sx={{ color: 'red' }}>{errors.internetListingDisplay}</FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex' }}>
                            <FormControl
                                fullWidth
                                required
                                variant="outlined"
                                error={touched.internetAutomatedValuation && Boolean(errors.internetAutomatedValuation)}
                            >
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Internet Automated Valuation Display
                                        </Typography>
                                    </FormLabel>
                                    <HelpIcon
                                        title={tips?.internetAutomatedValuation.title}
                                        ruleHelp={tips?.internetAutomatedValuation.ruleHelp}
                                        generalHelpDesc={tips?.internetAutomatedValuation.generalHelpDesc}
                                    />
                                </Box>
                                <RadioGroup
                                    name="internetAutomatedValuation"
                                    value={values.internetAutomatedValuation}
                                    onChange={handleChange}
                                    row
                                    sx={{ gap: 1, ml: 1, mt: 1 }}
                                >
                                    <FormControlLabel
                                        value="YES"
                                        control={<Radio />}
                                        label="YES"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />

                                    <FormControlLabel
                                        value="NO"
                                        control={<Radio />}
                                        label="NO"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />
                                </RadioGroup>
                                {/* <Field
                                    as={Select}
                                    name="internetAutomatedValuation"
                                    value={values.internetAutomatedValuation}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                >
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Field> */}
                                {touched.internetAutomatedValuation && errors.internetAutomatedValuation && (
                                    <FormHelperText sx={{ color: 'red' }}>{errors.internetAutomatedValuation}</FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex' }}>
                            <FormControl
                                fullWidth
                                required
                                variant="outlined"
                                error={touched.internetConsumerComment && Boolean(errors.internetConsumerComment)}
                            >
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Internet Consumer Comment
                                        </Typography>
                                    </FormLabel>
                                    <HelpIcon
                                        title={tips?.internetConsumerComment.title}
                                        ruleHelp={tips?.internetConsumerComment.ruleHelp}
                                        generalHelpDesc={tips?.internetConsumerComment.generalHelpDesc}
                                    />
                                </Box>
                                <RadioGroup
                                    name="internetConsumerComment"
                                    value={values.internetConsumerComment}
                                    onChange={handleChange}
                                    row
                                    sx={{ gap: 1, ml: 1, mt: 1 }}
                                >
                                    <FormControlLabel
                                        value="YES"
                                        control={<Radio />}
                                        label="YES"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />

                                    <FormControlLabel
                                        value="NO"
                                        control={<Radio />}
                                        label="NO"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />
                                </RadioGroup>

                                {touched.internetConsumerComment && errors.internetConsumerComment && (
                                    <FormHelperText sx={{ color: 'red' }}>{errors.internetConsumerComment}</FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex' }}>
                            <FormControl
                                fullWidth
                                required
                                variant="outlined"
                                error={touched.internetAddressDisplay && Boolean(errors.internetAddressDisplay)}
                            >
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Internet Address Display
                                        </Typography>
                                    </FormLabel>
                                    <HelpIcon
                                        title={tips?.internetAddressDisplay.title}
                                        ruleHelp={tips?.internetAddressDisplay.ruleHelp}
                                        generalHelpDesc={tips?.internetAddressDisplay.generalHelpDesc}
                                    />
                                </Box>
                                <RadioGroup
                                    name="internetAddressDisplay"
                                    value={values.internetAddressDisplay}
                                    onChange={handleChange}
                                    row
                                    sx={{ gap: 1, ml: 1, mt: 1 }}
                                >
                                    <FormControlLabel
                                        value="YES"
                                        control={<Radio />}
                                        label="YES"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />

                                    <FormControlLabel
                                        value="NO"
                                        control={<Radio />}
                                        label="NO"
                                        sx={{
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            padding: '2px 20px'
                                        }}
                                    />
                                </RadioGroup>
                                {/* <Field
                                    as={Select}
                                    name="internetAddressDisplay"
                                    value={values.internetAddressDisplay}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                >
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Field> */}
                                {touched.internetAddressDisplay && errors.internetAddressDisplay && (
                                    <FormHelperText sx={{ color: 'red' }}>{errors.internetAddressDisplay}</FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex' }}>
                            <FormControl fullWidth required error={touched.listingWillAppearOn && Boolean(errors.listingWillAppearOn)}>
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Listing Will Appear On
                                        </Typography>
                                    </FormLabel>
                                    <HelpIcon
                                        title={tips?.listingWillAppearOn.title}
                                        ruleHelp={tips?.listingWillAppearOn.ruleHelp}
                                        generalHelpDesc={tips?.listingWillAppearOn.generalHelpDesc}
                                    />
                                </Box>
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={[
                                        'ABOR.com (AustinHomeSearch)',
                                        'Apartments.com Network',
                                        'HAR.com',
                                        'ListHub',
                                        'Realtor.com',
                                        'Zillow Rentals'
                                    ]}
                                    value={values.listingWillAppearOn || []} // Handle value as an array
                                    onChange={(event, newValue) => {
                                        setFieldValue('listingWillAppearOn', newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            error={touched.listingWillAppearOn && Boolean(errors.listingWillAppearOn)}
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox checked={selected} />
                                            <ListItemText primary={option} />
                                        </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => option === value} // Compare options as strings
                                />
                                {touched.listingWillAppearOn && errors.listingWillAppearOn && (
                                    <FormHelperText>{errors.listingWillAppearOn}</FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                    </Grid>
                </Grid>
            </SubCard>
        </Grid>
    </Grid>
);

export default Remarks;
